import FieldInfo from './FieldInfo'

export default FieldInfo
